import { ApiClient, ApiErrorMessage } from './ApiClient';

export interface ClockType {
  now: Date;
  weekday: string;
}

export const ClockApi = async (): Promise<ClockType> => {
  try {
    const response = await ApiClient.get<ClockType>('/clock', {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return response.data;
  } catch (err) {
    const errorMsg = ApiErrorMessage(err);
    console.error(errorMsg);
  }

  return {
    now: new Date(),
    weekday: '火曜日'
  };
};
